module.exports = __webpack_public_path__ + "static/ogimage-d716472e41480ebe7512711fd6558e2b.png";